module.exports = __webpack_public_path__ + "public/img/发展历程OURDEVELOPMENT_CN.b98b3834.png";